import { apiClient as api } from './api';
import { Document, CreateDocumentRequest } from '../types/document';

export const documentApi = {
  // 직원의 문서 목록 조회
  getEmployeeDocuments: async (employeeId: number): Promise<Document[]> => {
    return await api.get<Document[]>(`/employees/${employeeId}/documents`);
  },

  // 문서 업로드
  uploadDocument: async (
    employeeId: number,
    file: File,
    documentData: CreateDocumentRequest
  ): Promise<Document> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('documentType', documentData.documentType);
    if (documentData.description) {
      formData.append('description', documentData.description);
    }

    const token = localStorage.getItem('accessToken');
    const apiUrl = `https://admin.grkcon.com/api/employees/${employeeId}/documents`;

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': token ? `Bearer ${token}` : '',
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Upload failed: ${response.status}`);
    }

    return await response.json();
  },

  // 문서 다운로드 (fetch + blob 방식)
  downloadDocument: async (documentId: number, fileName: string): Promise<void> => {
    const token = localStorage.getItem('accessToken');
    const url = `https://admin.grkcon.com/api/employees/documents/${documentId}/download`;
    const response = await fetch(url, {
      headers: {
        'Authorization': token ? `Bearer ${token}` : '',
      },
    });
    if (!response.ok) throw new Error(`Download failed: ${response.status}`);
    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
  },

  // 문서 파일 교체 (서명본 등)
  replaceDocument: async (documentId: number, file: File, uploadedBy?: string): Promise<Document> => {
    const formData = new FormData();
    formData.append('file', file);
    if (uploadedBy) {
      formData.append('uploadedBy', uploadedBy);
    }

    const token = localStorage.getItem('accessToken');
    const apiUrl = `https://admin.grkcon.com/api/employees/documents/${documentId}/replace`;

    const response = await fetch(apiUrl, {
      method: 'PUT',
      headers: {
        'Authorization': token ? `Bearer ${token}` : '',
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Replace failed: ${response.status}`);
    }

    return await response.json();
  },

  // 전체 다운로드 (개별 파일을 순차 다운로드)
  downloadAll: async (documents: Document[]): Promise<void> => {
    for (const doc of documents) {
      await documentApi.downloadDocument(doc.id, `${doc.originalName}${doc.fileExtension}`);
      await new Promise(r => setTimeout(r, 300));
    }
  },

  // 문서 정보 수정
  updateDocument: async (
    documentId: number,
    documentData: Partial<CreateDocumentRequest>
  ): Promise<Document> => {
    return await api.patch<Document>(`/employees/documents/${documentId}`, documentData);
  },

  // 문서 삭제
  deleteDocument: async (documentId: number): Promise<void> => {
    await api.delete<void>(`/employees/documents/${documentId}`);
  },
};
